<template>
  <div class="container">
    <van-nav-bar
      title="告警详情"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="list-box">
      <div class="list">告警时间：{{objDetail.createTime}}</div>
      <div class="list">所属项目：{{objDetail.communityFullName}}-{{objDetail.communityName}}</div>
      <div class="list">设备编号：{{objDetail.mainNo}}</div>
      <div class="list">插座编号：{{objDetail.loopNo}}</div>
      <div class="list">告警原因：{{objDetail.reasonDesc}}</div>
      
      <!-- 告警已处理 -->
      <div class="" v-if="warningStatus != 1">
        <div class="list">处理结果：{{objDetail.warningResultDesc}}</div>
        <div class="list message">告警描述：{{objDetail.description}}</div>
        <div class="list">
          <img v-if="objDetail.imgUrl" :src="imgDomain+objDetail.imgUrl+'?x-oss-process=style/w512'" alt="">
        </div>
      </div>
      

      <!-- 告警未处理 -->
      <div v-if="warningStatus == 1">
        <div class="list"> <span class="col_r">*</span> 处理结果：</div>
        <div class="btn-box">
          <span @click="selBtn(item)" :class="item.id == active?'active':''" class="btns" :key="index" v-for="(item,index) in warnResultList">{{item.description}}</span>
        </div>
        <div class="list">告警描述：</div>
        <div class="list">
          <van-field
            v-model="message"
            rows="3"
            autosize
            :border='true'
            label=""
            type="textarea"
            maxlength="100"
            placeholder="请输入告警描述"
          />
        </div>
        <div class="list"><span class="col_r">*</span> 现场照片：</div>
        <div class="upImg">
          <van-uploader
            v-model="imgList"
            :max-count="1"
            :max-size="10485760"
            :before-read="beforeRead"
            :before-delete="delImg"
          />
        </div>

        <div class="btnbox">
          <van-button color="#2FAAFF" round block type="info" @click="checkData">提交</van-button>
        </div>
      </div>
      
    </div>
    
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {uploadFiles} from '@/upload.js';
  import Vue from 'vue';
  import {NavBar,Icon,Toast,Loading,Field,Button,Uploader} from 'vant';
  import ImageCompressor from 'image-compressor.js' //js图片压缩旋转库
  export default {
    data() {
      return {
        fromPage:'',//来源是否是订阅号
        active:'',
        warningStatus: '',//告警状态
        rowId:'',
        warningResult:'',//告警原因
        imgList:[],
        upImgUrl:'',
        message:'',
        objDetail:{},
        warnResultList:[],
        imgDomain: location.protocol + "//soonsmart.keji.io/",
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Field.name]:Field,
      [Uploader.name]:Uploader,
      [Button.name]:Button,
    },
    methods: {
      changePage(Iccard,url){
        this.$router.push({path: url+".html",query:{iccard:Iccard}})
      },
      onClickLeft() {
        if(this.fromPage == 1){
          //从公众号进入
          Vue.wechat.closeWindow();
        }else{
          this.$router.go(-1);
        }
      },
      selBtn(item){
        this.active = item.id;
        this.warningResult = item.id;
      },
      beforeRead(file) {
        var that = this;
        if(file.length != undefined){
          Toast('只能选择1张图片');
          return false;
        }
        if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png' && file.type !== 'image/bmp') {
          Toast('请上传 jpg jpeg png bmp 格式图片');
          return false;
        } else if (file.size > 10485760 ) {
          Toast('请上传不大于 10M 的图片');
          return false;
        } else{
          new ImageCompressor(file, {
            quality: 0.6, //压缩质量
            checkOrientation: false,//指示是否读取图像的Exif方向值(仅为JPEG图像)，然后使用该值自动旋转或翻转图像。默认true
            success(result) {
              //压缩后的文件会自动转换成二进制文件流类型
              //这里可以发ajax，上传图片
              Toast.loading({
                duration: 0,       // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '图片上传中...'
              });
              that.uprightSuc(result.name,result);
            }
          })
          return true;
        }
        
      },
      delImg(){
        this.upImgUrl = '';
        return true;
      },
      uprightSuc(imgName, imgFile) {
          let that = this;
          uploadFiles(imgName, imgFile)         
          .then(function (result) {
            that.upImgUrl = result.name;
            Toast.clear();
          })
          .catch(function (err) {
            console.log('err', err)
          })
      },
      
      checkData(){
        if(this.warningResult === ''){
          Toast('请选择处理结果');
          return false;
        }else if(this.upImgUrl == ''){
          Toast('请上传现场照片');
          return false;
        }else{
          this.upCheckList();
        }
      },
      upCheckList() {
        //上传
        Toast.loading({
          duration: 0,       // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: 'spinner',
          message: '提交中...'
        });
        axios.post("/device/operatordevicewarning",{
          id: this.rowId,
          warningResult: this.warningResult,
          description: this.message,
          imageList: [
            this.upImgUrl
          ]
        }).then((res)=>{
          if(res.isSuccess){
            Toast('提交成功');
            setTimeout(()=>{
              //this.onClickLeft();
              this.$router.push({path: "warn.html",query:{isDetail:1}})
            },1500)
          }
        })
      },
      getDetail() {
        //获取详情
        axios.get("device/devicewarningdetail?id="+this.rowId,{
        }).then((res)=>{
          this.objDetail = res.data;
          if(res.data.deviceWarningImageList.length > 0){
            this.objDetail.imgUrl = res.data.deviceWarningImageList[0].imageUrl;
          }else{
            this.objDetail.imgUrl = '';
          }
          this.warningStatus = res.data.warningStatus;
        })

        //处理结果
        axios.get("/common/getwarningresult",{
        }).then((res)=>{
          this.warnResultList = res.data;
        })

        //标记已读
        axios.get("/device/readdevicewarning?id="+this.rowId,{
        }).then(()=>{
        })
      },
      getUrlParam (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let r = (window.location.search.substr(1) || window.location.hash.split('?')[1])['match'](reg)
        if (r != null) return decodeURI(unescape(r[2]))
        else return null
      },
     
    },
    computed:{},
    created () {
      this.rowId = this.$route.query.rowId;
      this.fromPage = this.$route.query.fromPage;
      this.getDetail();
    },
    mounted () {
    },
  }
</script>

<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #fff}
  .container{
    width: 100%;min-height: 100vh;letter-spacing:0px;background: #fff;
    padding-bottom: 100px;
  }
  .list-box{
    width: 100%;
    color: #373737;
    padding: 12px 20px 0 20px;
    .list{
      font-size: 14px;
      width: 100%;
      margin-bottom: 10px;
      .width200{width: 200px; display: inline-block;}
    }
    img{width: 100%;}
  }
  .btns{
    width: 86px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    border: 1px solid #c8d1db;
    border-radius: 4px;
    margin: 0 10px 20px 0;
  }
  .message{
    width: 100%;
    word-break: break-all;
  }
  .active{
    color: #fff;
    background: #2FAAFF;
    border: 1px solid #2FAAFF;
  }
  .upImg{
    .van-uploader__upload{width: 60px !important;height: 60px !important;}
  }

  .btnbox{
    width: 100%;
    padding: 0 30px;
    position: fixed;
    left: 0;
    bottom: 40px;
  }
  /deep/.van-field{
    border: 1px solid #c8d1db;
    border-radius: 4px;
  }
</style>
